import { useCallback } from 'react';
import { expiringTokensWebSocketService } from '../classes/ExpiringTokensWebSocketService';
import { useFeatureFlag } from '@tradingblock/components';
import { webSocketService } from '../classes/WebSocketService';

export const useExpiringTokensWebSocket = () => {
  const { isEnabled: useLofiExpiringTokens } = useFeatureFlag('lofi-expiring-tokens');

  const trySendExpiringTokensCmd = useCallback((cmd: string) => {
    try {
      if (useLofiExpiringTokens) {
        expiringTokensWebSocketService.sendMessage(cmd);
      } else {
        webSocketService.sendMessage(cmd);
      }
      return true;
    } catch (ex) {
      console.warn('useExpiringTokensWebSocket :: Caught error trying to send order status cmd "', cmd, '": ', ex);
      // throw ex;
    }
    return false;
  }, [useLofiExpiringTokens]);

  const unsubscribeExpiringTokens = useCallback(() => {
    const cmd = JSON.stringify({
      type: 'Unsubscribe',
    });
    return trySendExpiringTokensCmd(cmd);
  }, [trySendExpiringTokensCmd]);

  return { unsubscribeExpiringTokens };
};
